import styled from 'styled-components';

export const StyledHeader = styled.header`
  background-color: ${({ theme }) => theme.color.primary};
  width: 100vw;
  height: 8rem;
  top: 0;
  left: 0;
  display: flex;
`;
